// translations/en.js - English translations for Operator App
export const en = {
  // Dashboard Page
  "dashboard.title": "QA Audit Dashboard",
  "dashboard.welcome": "Welcome to Quality Assurance Operations",
  "dashboard.subtitle": "Digital Quality Audit System",
  "dashboard.select_form": "Select Audit Form",
  "dashboard.recent_audits": "Recent Audits",
  "dashboard.statistics": "Statistics",
  "dashboard.start_new_audit": "Start New Audit",
  "dashboard.enter_serial": "ENTER the Serial Number",
  "dashboard.scan_serial": "SCAN Chiller Serial Number",
  "dashboard.show_debug": "Show Debug Info",
  "dashboard.hide_debug": "Hide Debug Info",
  "dashboard.debug_info": "Debug Information",
  "dashboard.wip_audit": "Work in Progress Audit",
  "dashboard.avg_time_per_audit": "Average Time per Audit",
  "dashboard.hrs": "Hrs",
  "dashboard.audits_up_to_date": "Audits up to date",
  "dashboard.average_score": "Average Score",
  "dashboard.completed_audits": "Completed Audits",
  "dashboard.draft_audits": "Work in Progress Audits",
  "dashboard.table_sn": "SN",
  "dashboard.table_chiller_sn": "CHILLER S/N",
  "dashboard.table_score": "SCORE",
  "dashboard.table_ov": "OV #",
  "dashboard.table_model": "MODEL #",
  "dashboard.table_pl": "PL #",
  "dashboard.table_date_time": "DATE & TIME",
  "dashboard.table_action": "ACTION",
  "dashboard.view_audit_details": "View audit details",
  "dashboard.showing_audits": "Showing",
  "dashboard.of_audits": "of",
  "dashboard.audits": "audits",
  "dashboard.previous": "Previous",
  "dashboard.next": "Next",
  "dashboard.no_completed_audits": "No completed audits available",
  "dashboard.completed_audits_appear": "Completed audits will appear here once available",
  "dashboard.draft": "DRAFT",
  "dashboard.resume": "Resume",
  "dashboard.showing_drafts": "Showing",
  "dashboard.of_drafts": "of",
  "dashboard.drafts": "drafts",
  "dashboard.no_draft_audits": "No draft audits in progress",

  // Navigation
  "nav.dashboard": "Dashboard",
  "nav.audit": "Audit",
  "nav.categories": "Categories",
  "nav.control_items": "Control Items",
  "nav.checklist": "Checklist",
  "nav.summary": "Summary",

  // Common Buttons
  "btn.next": "Next",
  "btn.back": "Back",
  "btn.previous": "Previous",
  "btn.dashboard": "Dashboard",
  "btn.save": "Save",
  "btn.cancel": "Cancel",
  "btn.complete": "Complete",
  "btn.continue": "Continue",
  "btn.start": "Start",
  "btn.finish": "Finish",
  "btn.submit": "Submit",
  "btn.close": "Close",
  "btn.edit": "Edit",
  "btn.view": "View",
  "btn.download": "Download",
  "btn.export": "Export",

  // Status Labels
  "status.completed": "Completed",
  "status.draft": "Draft mode",
  "status.not_started": "Not yet started",
  "status.in_progress": "In Progress",
  "status.pending": "Pending",
  "status.label": "Status",
  "status.published": "Published",

  // Common Messages
  "msg.loading": "Loading...",
  "msg.saving": "Saving...",
  "msg.save_success": "Saved successfully",
  "msg.save_error": "Save failed",
  "msg.error": "Error",
  "msg.success": "Success",
  "msg.no_data": "No data available",

  // Form Labels
  "form.serial_number": "Serial Number",
  "form.unit_model": "Unit Model",
  "form.production_line": "Production Line",
  "form.operator": "Operator",
  "form.date": "Date",
  "form.time": "Time",

  // Unit Details Form
  "unit.title": "Unit Details",
  "unit.back": "Back",
  "unit.serial_number": "Serial Number",
  "unit.work_order": "Work Order",
  "unit.unit_model": "Unit Model (Product)",
  "unit.production_line": "Production Line - {0} available",
  "unit.date_time": "Date and Time",
  "unit.unit_lock": "Unit Lock",
  "unit.locked": "Locked",
  "unit.unlocked": "Unlocked",
  "unit.enter_serial": "Enter serial number manually",
  "unit.scan_serial": "Serial number from scanner",
  "unit.enter_work_order": "Enter work order",
  "unit.enter_unit_model": "Enter unit model",
  "unit.select_production_line": "Select production line",
  "unit.no_production_lines": "No production lines available",
  "unit.loading_production_lines": "Loading production lines...",
  "unit.unit_is": "Unit is {0}",
  "unit.continue": "Continue",

  // Category View Page
  "category.title": "Category Page",
  "category.audit_session": "Audit Session",
  "category.work_started": "Work Started",
  "category.product_serial": "Product Serial",
  "category.current_score": "Current Score",
  "category.points": "points",
  "category.form_details": "Form Details",
  "category.start_complete_audit": "Start Complete Audit",
  "category.all_categories": "(All Categories)",
  "category.select_individual": "Or select individual categories:",
  "category.loading_categories": "Loading categories...",
  "category.error_loading_form": "Error loading form data",
  "category.no_categories": "No Categories Available",
  "category.no_categories_desc": "No categories found for the selected form.",
  "category.control_items_completed": "Control Items Completed",
  "category.form_name": "Form Name",
  "category.form_code": "Form Code",
  "category.italian_name": "Italian Name",
  "category.total_fields": "Total Fields",
  "category.total_points": "Total Points",
  "category.passing_threshold": "Passing Threshold",
  "category.production_line": "Production Line",
  "category.line_name": "Line Name",
  "category.line_id": "Line ID",
  "category.product": "Product",
  "category.product_name": "Product Name",
  "category.model_number": "Model Number",
  "category.categories": "Categories",
  "category.items": "Items",
  "category.status_dates": "Status & Dates",
  "category.created": "Created",
  "category.loading_form_details": "Loading form details...",
  "category.error_loading_details": "Error loading form details",
  "category.no_detailed_data": "No detailed form data available",

  // Checklist Page Loop
  "checklist.category_completed": "Category Completed",
  "checklist.completed": "✓ Completed",
  "checklist.next_category": "Next Category",
  "checklist.all_complete": "🎉 All Categories Complete!",
  "checklist.categories_reviewed": "⚠️ Categories Reviewed",
  "checklist.ready_for_summary": "Audit is ready for summary",
  "checklist.items_need_completion": "{0} control item{1} still need{2} completion",
  "checklist.each_item_requirement": "Each control item must have at least one check marked to be considered complete.",
  "checklist.progress": "Progress",
  "checklist.of_categories": "of {0} categories",
  "checklist.stay_here": "Stay Here",
  "checklist.continue": "Continue",
  "checklist.go_to_summary": "Go to Summary",
  "checklist.try_to_continue": "Try to Continue",
  "checklist.no_categories_available": "No Categories Available",
  "checklist.no_categories_found": "No categories found for this audit form.",
  "checklist.no_control_items": "No Control Items",
  "checklist.no_control_items_found": "No control items found for the current category.",
  "checklist.next": "Next",
  "checklist.previous": "Previous",
  "checklist.uploading_images": "Uploading images...",
  "checklist.saving_progress": "Saving progress...",
  "checklist.image_uploads_disabled": "Image uploads disabled",
  "checklist.saved_successfully": "Saved successfully",
  "checklist.category": "Category",
  "checklist.score": "Score",
  "checklist.control_items": "Control Items",
  "checklist.categories": "Categories",
  "checklist.dashboard": "Dashboard",
  "checklist.check_description": "Check Description",
  "checklist.quantity": "Quantity",
  "checklist.pictures": "Pictures",
  "checklist.comment": "Comment",
  "checklist.fixed_before_shipment": "Fixed before Shipment",
  "checklist.production_phase": "Production Phase",
  "checklist.category_of": "Category {0} of {1}",
  "checklist.comment_for": "Comment for: {0}",
  "checklist.save_comment": "Save Comment",
  "checklist.view_full_size": "View full size",
  "checklist.remove_image": "Remove image",
  "checklist.add_picture": "Add Picture",
  "checklist.add_comment": "Add Comment",
  "checklist.view_comment": "View Comment",
  "checklist.no_check_items": "No Check Items",
  "checklist.no_check_items_desc": "This control item doesn't have any check items defined.",
  "checklist.loading": "Loading...",
  "checklist.previous": "Previous",
  "checklist.next": "Next",
  "checklist.saving": "Saving...",
  "checklist.complete_required": "Complete Required Fields",
  "checklist.complete_tooltip": "Complete all required fields: Group B items need image + comment",
  "checklist.control_item_of": "Control Item {0} of {1}",
  "checklist.images_for": "Images for: {0}",
  "checklist.images_count": "{0} image(s)",
  "checklist.no_images": "No images uploaded yet",
  "checklist.use_camera": "Use the camera icon to add images",
  "checklist.cloud_storage": "Images stored in cloud",
  "checklist.cloud_not_configured": "Cloud storage not configured",
  "checklist.add_more_images": "Add More Images",
  "checklist.add_image": "Add Image",
  "checklist.choose_method": "Choose how you want to add an image:",
  "checklist.take_photo": "Take Photo",
  "checklist.upload_file": "Upload File",
  "checklist.position_camera": "Position your camera and tap the capture button",
  "checklist.retake": "Retake",
  "checklist.save_image": "Save Image",
  "checklist.compress_note": "Image will be compressed to under 200KB for optimal upload",
  "checklist.cancel": "Cancel",
  "checklist.clear": "Clear",
  "checklist.enter_comment": "Enter your comment...",
  "checklist.phase": "Phase",
  "checklist.phase_planning": "Planning",
  "checklist.phase_development": "Development",
  "checklist.phase_testing": "Testing",
  "checklist.phase_production": "Production",
  "checklist.phase_complete": "Complete",

  // Form Selection Page
  "forms.title": "Select from the Available Forms",
  "forms.back": "Back",
  "forms.refresh": "Refresh",
  "forms.loading": "Loading...",
  "forms.loading_forms": "Loading audit forms...",
  "forms.loading_form": "Loading form...",
  "forms.no_forms_available": "No Forms Available",
  "forms.no_forms_desc": "No audit forms are currently available for selection.",
  "forms.contact_admin": "Contact your administrator or try refreshing the page.",
  "forms.retry": "Retry",
  "forms.select_form": "Select {0} form",
  "forms.code": "Code",
  "forms.fields": "Fields",
  "forms.points": "Points",
  "forms.line": "Line",
  "forms.created": "Created",

  // Audit Summary Page
  "summary.title": "Audit Summary",
  "summary.review_before_submit": "Review your audit before final submission",
  "summary.back_to_audit": "Back to Audit",
  "summary.submit_audit": "Submit Audit",
  "summary.submitting": "Submitting...",
  "summary.no_images": "No images",
  "summary.complete": "Complete",
  "summary.incomplete": "Incomplete",
  "summary.not_started": "Not Started",
  "summary.edit": "Edit",
  "summary.points": "pts",
  "summary.go_back": "Go Back to Audit",
  "summary.confirm_submission": "Are you sure you want to submit this audit?",
  "summary.no_changes_after": "You will not be able to make changes after submission.",
  "summary.audit_summary_stats": "📊 Audit Summary:",
  "summary.control_items_completed": "control items completed",
  "summary.need_changes": "Need to make changes? Click **\"Back to Audit\"** to continue editing.",
  "summary.ready_finalize": "Ready to finalize? Click **\"Submit Audit\"** to complete the process.",

  // QGS-only summary page
  "summary.qgs_subtitle": "Open KOs and Rework items captured during this gate audit",
  "summary.qgs_audit_info": "Audit Information",
  "summary.qgs_session": "Session",
  "summary.qgs_form": "Form",
  "summary.qgs_gate": "Gate",
  "summary.qgs_serial": "Serial",
  "summary.qgs_started": "Started",
  "summary.qgs_status": "Status",
  "summary.qgs_open_ko": "Open KOs",
  "summary.qgs_rework": "Rework",
  "summary.dashboard": "Dashboard",
  "summary.qgs_open_ko_heading": "Open KOs ({count})",
  "summary.qgs_rework_heading": "Rework Records ({count})",
  "summary.qgs_no_kos": "No KOs raised on this audit.",
  "summary.qgs_no_reworks": "No Rework records on this audit.",
  "summary.qgs_synced": "SYNCED",
  "summary.qgs_pending_sync": "PENDING SYNC",
  "summary.qgs_no_sync_hint": "Counts will update once you press Next on a control item with KO / Rework rows.",

  // Control Items View Page
  "control_items.title": "Control Items",
  "control_items.back_to_categories": "Back to Categories",
  "control_items.no_items": "No Control Items",
  "control_items.no_items_desc": "No control items found for this category.",
  "control_items.loading": "Loading control items...",
  "control_items.select_item": "Select control item",
  "control_items.completed": "Completed",
  "control_items.not_started": "Not Started",
  "control_items.in_progress": "In Progress",
  "control_items.audit_session": "AUDIT SESSION",
  "control_items.work_started": "WORK STARTED",
  "control_items.product_serial": "PRODUCT SERIAL",
  "control_items.current_score": "CURRENT SCORE",
  "control_items.points": "points",
  "control_items.form_details": "Form Details",
  "control_items.control_items_in": "Control Items in",
  "control_items.continue_incomplete": "Continue with incomplete item below",
  "control_items.next_item": "Next item:",
  "control_items.look_for": "Look for the",
  "control_items.continue_indicator": "Continue from here",
  "control_items.category_completed": "Category completed!",
  "control_items.all_items_completed": "All control items in this category have been completed. You can review completed items or return to categories to continue with other categories.",
  "control_items.loading_control_items": "Loading control items...",
  "control_items.error_loading_form": "Error loading form data",
  "control_items.checks": "Checks",
  "control_items.no_available": "No Control Items Available",
  "control_items.no_found_category": "No control items found for the selected category.",
  "control_items.next": "Next",
  "control_items.details": "Details",

  // Checklist Page
  "checklist_page.back": "Back",
  "checklist_page.next": "Next",
  "checklist_page.submit": "Submit",
  "checklist_page.save_draft": "Save Draft",
  "checklist_page.add_comment": "Add Comment",
  "checklist_page.take_photo": "Take Photo",
  "checklist_page.upload_image": "Upload Image",
  "checklist_page.comment_placeholder": "Add your comment here...",
  "checklist_page.required_for_defects": "Required for defects",
  "checklist_page.optional": "Optional",

  // Login Screen
  "login.title": "QA Operations Login",
  "login.welcome": "Welcome to Quality Assurance Operations",
  "login.username": "Username",
  "login.password": "Password",
  "login.login_button": "Login",
  "login.logging_in": "Logging in...",
  "login.enter_username": "Enter your username",
  "login.enter_password": "Enter your password",
  "login.invalid_credentials": "Invalid credentials",
  "login.login_failed": "Login failed",

  // Summary Item Page
  "summary_item.loading_form_details": "Loading form details...",
  "summary_item.error_loading_details": "Error loading form details",
  "summary_item.no_detailed_data": "No detailed form data available",
  "summary_item.form_name": "Form Name",
  "summary_item.form_code": "Form Code",
  "summary_item.italian_name": "Italian Name",
  "summary_item.total_fields": "Total Fields",
  "summary_item.total_points": "Total Points",
  "summary_item.passing_threshold": "Passing Threshold",
  "summary_item.loading_results": "Loading audit results...",
  "summary_item.error_loading_results": "Error Loading Results",
  "summary_item.try_again": "Try Again",
  "summary_item.go_back_dashboard": "Go Back to Dashboard",
  "summary_item.audit_summary": "Audit Summary",
  "summary_item.control_items_summary": "Control Items Audit Summary",
  "summary_item.status": "Status",
  "summary_item.form_details": "Form Details",
  "summary_item.audit_details": "Audit Details",
  "summary_item.audit_form": "Audit Form",
  "summary_item.audit_session_id": "Audit Ref #",
  "summary_item.failed_control_items": "Failed Control Items",
  "summary_item.go_back_audit": "Go back to audit",
  "summary_item.audit_completed": "Audit Completed",
  "summary_item.details": "Details",
  "summary_item.result": "Result",
  "summary_item.submitted": "Submitted",
  "summary_item.unit_information": "Unit Information",
  "summary_item.serial_number": "Serial Number",
  "summary_item.unit_model": "Unit Model",
  "summary_item.date_time": "Date and Time",
  "summary_item.work_order": "Work Order (OV)",
  "summary_item.production_line": "Production Line",
  "summary_item.unit_lock": "Unit Lock",
  "summary_item.operator": "Operator",
  "summary_item.form": "Form",
  "summary_item.final_score": "Final Score",
  "summary_item.max_points": "Max points -",
  "summary_item.passing_threshold_label": "Passing Threshold:",
  "summary_item.total_control_items": "Total Control Items:",
  "summary_item.passed_control_items": "Passed Control Items:",
  "summary_item.critical_issues": "Critical Issues:",
  "summary_item.na": "N/A",
  "summary_item.unknown_operator": "Unknown Operator",

  // Language Toggle
  "lang.english": "English",
  "lang.italian": "Italiano",
  "lang.switch_to": "Switch to {0}",

  // Additional Audit Summary translations
  "summary.close": "×",
  "summary.edit": "Edit",
  "summary.attached_images": "Attached Images",
  "summary.missing_required": "Missing required:",
  "summary.image": "image",
  "summary.and": "and",
  "summary.comment": "comment",
  "summary.audit_information": "Audit Information",
  "summary.progress_overview": "Progress Overview",
  "summary.categories": "Categories",
  "summary.control_items": "Control Items",
  "summary.checks_selected": "Checks Selected",
  "summary.images_uploaded": "Images Uploaded",
  "summary.validation_status": "Validation Status",
  "summary.errors": "Errors:",
  "summary.warnings": "Warnings:",
  "summary.ready_for_submission": "✓ Audit is ready for submission",
  "summary.detailed_review": "Detailed Review",
  "summary.review_categories_items": "Review all categories and control items. Click \"Edit\" to make changes.",
  "summary.edit_category": "Edit Category",
  "summary.no_control_items_found": "No control items found in this category",
  "summary.irreversible_action": "This is an irreversible action!",
  "summary.final_audit_submission": "Final Audit Submission",
  "summary.cannot_make_changes": "Once you submit this audit, you will not be able to make any changes. Please ensure all information is accurate and complete.",
  "summary.audit_summary_stats": "📊 Audit Summary:",
  "summary.control_items_completed": "control items completed",
  "summary.check_items_selected": "check items selected",
  "summary.images_uploaded_count": "images uploaded",
  "summary.all_validations_passed": "All validations passed",
  "summary.need_changes": "Need to make changes? Click \"Back to Audit\" to continue editing.",
  "summary.ready_finalize": "Ready to finalize? Click \"Submit Audit\" to complete the process.",
  "summary.no_audit_data": "No Audit Data Available",
  "summary.complete_audit_items": "Please complete some audit items before viewing the summary.",
  "summary.id": "ID:",
  "summary.created": "Created:",
  "summary.serial": "Serial:",
  "summary.today": "Today",
  "summary.na": "N/A",

  // Validation and Toast Messages
  "summary.no_control_items_to_audit": "No control items found to audit",
  "summary.no_check_items_selected": "No check items have been selected",
  "summary.score_calculation_incomplete": "Score calculation may not be complete",
  "summary.cannot_submit_with_errors": "Cannot submit audit with validation errors. Please review and complete all required fields.",
  "summary.warnings_review_before_submit": "There are some warnings. Please review before submitting.",
  "summary.audit_submitted_success": "Audit submitted successfully!",
  "summary.failed_to_submit": "Failed to submit audit. Please try again.",
  "summary.problems_only": "Problems Only",
  "summary.all_items": "All Items",
  "summary.showing_problems_count": "Showing {0} control items with issues",
  "summary.items_with_no_problems": "items with no problems are hidden",
  "summary.no_problems_detected": "No Problems Detected!",
  "summary.all_control_items_passed": "All control items have passed. Great job!",
  "summary.view_all_items": "View All Items",
  "summary.category_deductions": "Category Deductions",
  "summary.total_deductions": "Total Deductions",
  "summary.total_score": "Total Score",
  "summary.completed": "Completed",
  "summary.ongoing": "Ongoing",
  "summary.not_started": "Not Started",
  "summary.total": "Total",
};